<template>
    <input id="assigned-group" type="text" class="h-full w-full px-2 transition-all border-blue-gray rounded text-blue"
           v-model="searchTerm"
           @keyup="updateActiveStatus"
           @change="checkMatch"
    >
    <label for="assigned-group" class="absolute left-2 transition-all px-1 text-blue-gray"> {{ label }} </label>

    <div v-if="searchResult.length" :class="{ hidden: !active }"
        class="w-full bg-white border border-blue-gray rounded absolute z-10 mt-2 max-h-48 overflow-y-auto" >
        <div v-for="item in searchResult"
            :key="item.id"
            @click="selectOption(item)"
            class="cursor-pointer hover:bg-gray-100 px-2 py-2 text-blue" >
            {{ item.name }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Autocomplete",
        data() {
            return {
                active: true,
                searchTerm: '',
                selectedOption: null
            }
        },
        props: ['options', 'selected', 'label'],
        computed: {
            searchResult: function () {
                if (this.searchTerm === '') {
                    return []
                }
                return this.options.filter(item => {
                    if (item.name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
                        return item
                    }
                })
            },
        },
        emits: ['update:selected', 'update:text'],

        watch: {
            selected: {
                handler(value){
                    this.checkMatchByID(value);
                },
            },
            options: {
                handler(){
                    this.checkMatchByID(this.selected);
                },
            }
        },

        methods: {
            checkMatchByID(id){
                if(id){
                    let matchOption = this.options.find(item => {
                        if (item.id == id) {
                            return item;
                        }
                    });
                    if(matchOption){
                        this.selectOption(matchOption);
                    }
                }
            },
            checkMatch(){
                if(this.searchTerm.length){
                    let matchOption = this.options.find(item => {
                        if (item.name.toLowerCase().trim() == this.searchTerm.toLowerCase().trim()) {
                            return item;
                        }
                    });
                    if(matchOption){
                        this.selectOption(matchOption);
                    }else{
                        this.$emit('update:selected', -1);
                    }
                }else{
                    this.$emit('update:selected', 0);
                }
            },
            updateActiveStatus(){
                if(this.searchTerm.length){
                    this.active = true;
                }else{
                    this.active = false;
                }
                this.$emit('update:text', this.searchTerm);
            },
            selectOption(item){
                this.selectedOption = item;
                this.searchTerm = item.name;
                this.active = false;
                this.$emit('update:selected', item.id);
            }
        }
    }
</script>

<style scoped>

</style>
